module.exports = __webpack_public_path__ + "static/media/file-user.a1b5c659.svg";